import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../LanguageChange/LanguageChange.scss';
import { Dropdown } from 'react-bootstrap';
import { ENGLISH, GERMAN, SELECTED_LANGUAGE } from 'utils/enums/misc';
import { capitalizeFirstLetter } from 'utils/helpers';
import { getCookie, setCookie } from 'utils/cookieUtils';
import { UilGlobe } from '@iconscout/react-unicons';

const LanguageChange = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState<
    typeof ENGLISH | typeof GERMAN
  >(GERMAN);
  const dropdownRef: React.RefObject<HTMLDivElement> = useRef(null);

  const languages: {
    id: typeof ENGLISH | typeof GERMAN;
    name: string;
  }[] = [
    {
      id: ENGLISH,
      name: capitalizeFirstLetter(t('header.drop_down.value_3'))
    },
    {
      id: GERMAN,
      name: capitalizeFirstLetter(t('header.drop_down.value_4'))
    }
  ];

  useEffect(() => {
    const savedLanguage: typeof ENGLISH | typeof GERMAN =
      getCookie(SELECTED_LANGUAGE)!;
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (lang: typeof ENGLISH | typeof GERMAN) => {
    setCookie(SELECTED_LANGUAGE, lang);
    setCurrentLanguage(lang);
    setIsOpen(false);
    window.location.reload();
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef?.current?.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div id="LanguageChange" className="position-absolute right-10">
      <Dropdown className="m-2">
        <Dropdown.Toggle className="dropdown-toggle d-flex align-items-center  border  cursor-pointer font-medium px-3 py-2 border-radius-6 text-body bg-body gap-3">
          <UilGlobe />
          <span className="me-auto font-light fs-16 ">
            {capitalizeFirstLetter(t('login_signup.language'))}
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu p-0" align="start">
          {languages.map(lang => (
            <Dropdown.Item
              key={lang.id}
              onClick={() => {
                handleLanguageChange(lang.id);
              }}
              className={` fs-16 ${
                lang.id === currentLanguage
                  ? 'bg-danger text-white'
                  : 'hover-danger'
              }`}
            >
              {lang.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LanguageChange;
